import React, { useMemo } from 'react';
import {
  Box,
  Text,
  VStack,
  Heading,
} from '@gluestack-ui/themed';
import type { Task } from '@/common/api/models/task';
import TaskFeedbackCard from '@/student/grade/components/parts/TaskFeedbackCard';

interface TaskFeedbackListProps {
  tasks: Task[];
  title: string;
  showLevels?: boolean;
}

const TaskFeedbackList: React.FC<TaskFeedbackListProps> = ({ tasks, title, showLevels = true }) => {
  const tasksByLevel = useMemo(() => {
    if (!showLevels) {
      return new Map([[0, tasks]]);
    }

    const grouped = new Map<number, Task[]>();
    tasks.forEach((task) => {
      if (!grouped.has(task.level)) {
        grouped.set(task.level, []);
      }
      grouped.get(task.level)?.push(task);
    });
    return new Map([...grouped.entries()].sort((a, b) => a[0] - b[0]));
  }, [tasks, showLevels]);

  return (
    <Box p="$2">
      <VStack space="lg">
        <Heading size="md">{title}</Heading>
        <VStack space="lg">
          {Array.from(tasksByLevel.entries()).map(([level, levelTasks]) => (
            <VStack key={level} space="sm">
              {showLevels && (
                <Text size="2xs" color="$textSubtle" textTransform="uppercase" letterSpacing="$sm" mb="$2">
                  Level
                  {' '}
                  {level}
                </Text>
              )}
              {levelTasks.map((task) => (
                <TaskFeedbackCard key={task.id} task={task} allTasks={tasks} />
              ))}
            </VStack>
          ))}
        </VStack>
      </VStack>
    </Box>
  );
};

export default TaskFeedbackList;
